"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorPlaceholderInternal = void 0;
var inversify_react_1 = require("inversify-react");
var react_1 = __importDefault(require("react"));
var slate_1 = require("slate");
var EditorTypes_1 = require("../EditorTypes");
var PlaceholderContext_1 = require("./PlaceholderContext");
var styles = __importStar(require("./EditorPlaceholder.css"));
var SlateSelectionStore_1 = require("../SlateSelectionStore");
var slate_react_1 = require("slate-react");
var FilterableColorProvider_1 = require("../Styling/FilterableColorProvider");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var dynamic_1 = require("@vanilla-extract/dynamic");
var EditorPlaceholder = function (props) {
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    return react_1.default.createElement(EditorPlaceholderInternal, __assign({}, props, { colorProvider: colorProvider }));
};
exports.default = EditorPlaceholder;
var EditorPlaceholderInternal = (function (_super) {
    __extends(EditorPlaceholderInternal, _super);
    function EditorPlaceholderInternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EditorPlaceholderInternal.prototype, "placeholderText", {
        get: function () {
            var element = this.props.element;
            var isInlineElement = slate_1.Editor.isInline(this.editor, element);
            var elementContainsText = slate_1.Node.string(element) !== "";
            var elementContainsNonTextContent = element.children.some(function (child) { return !slate_1.Text.isText(child); });
            if (isInlineElement || elementContainsText || elementContainsNonTextContent) {
                return;
            }
            var tagConfig = this.placeholderConfig[element.type];
            if (!tagConfig) {
                return;
            }
            else if (typeof tagConfig === "string") {
                return tagConfig;
            }
            else {
                try {
                    var pathOfElement = slate_react_1.ReactEditor.findPath(this.editor, element);
                    var parentNode = slate_1.Node.parent(this.editor, pathOfElement);
                    var isOnlyChild = parentNode.children.length === 1;
                    var _a = this.selectionStore, focussed = _a.focussed, currentSelection = _a.currentSelection;
                    var isFocussed = focussed &&
                        !!currentSelection &&
                        slate_1.Range.isCollapsed(currentSelection) &&
                        slate_1.Path.equals(pathOfElement, slate_1.Path.parent(currentSelection.anchor.path));
                    return tagConfig({ element: element, isFocussed: isFocussed, isOnlyChild: isOnlyChild });
                }
                catch (error) {
                    return;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditorPlaceholderInternal.prototype, "placeholderColor", {
        get: function () {
            var children = this.props.element.children;
            if (children.length !== 1) {
                return undefined;
            }
            var _a = __read(children, 1), child = _a[0];
            if (!slate_1.Text.isText(child) || child.text.length > 0) {
                return undefined;
            }
            var maybeColorMark = child.marks.find(function (m) { return m.type === EditorTypes_1.MarkType.Color; });
            if (!maybeColorMark) {
                return undefined;
            }
            var decoratedColor = this.props.colorProvider.decorateColor((0, GetBlockStyle_1.convertColorObjToColor)(maybeColorMark.data.color));
            return decoratedColor.value;
        },
        enumerable: false,
        configurable: true
    });
    EditorPlaceholderInternal.prototype.render = function () {
        var _a;
        var _b = this, placeholderText = _b.placeholderText, placeholderColor = _b.placeholderColor;
        if (!placeholderText) {
            return null;
        }
        return (react_1.default.createElement("span", { contentEditable: false, className: styles.editorPlaceholder, style: !!placeholderColor
                ? (0, dynamic_1.assignInlineVars)((_a = {}, _a[styles.editorPlaceholderOverrideColor] = placeholderColor, _a))
                : undefined }, placeholderText));
    };
    var _a, _b, _c;
    __decorate([
        (0, inversify_react_1.resolve)(PlaceholderContext_1.PlaceholderConfig.$),
        __metadata("design:type", typeof (_a = typeof PlaceholderContext_1.PlaceholderConfig !== "undefined" && PlaceholderContext_1.PlaceholderConfig) === "function" ? _a : Object)
    ], EditorPlaceholderInternal.prototype, "placeholderConfig", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(EditorTypes_1.SlateEditor.$),
        __metadata("design:type", typeof (_b = typeof EditorTypes_1.SlateEditor !== "undefined" && EditorTypes_1.SlateEditor) === "function" ? _b : Object)
    ], EditorPlaceholderInternal.prototype, "editor", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(SlateSelectionStore_1.SlateSelectionStore),
        __metadata("design:type", typeof (_c = typeof SlateSelectionStore_1.SlateSelectionStore !== "undefined" && SlateSelectionStore_1.SlateSelectionStore) === "function" ? _c : Object)
    ], EditorPlaceholderInternal.prototype, "selectionStore", void 0);
    return EditorPlaceholderInternal;
}(react_1.default.Component));
exports.EditorPlaceholderInternal = EditorPlaceholderInternal;
